package one.devsbox.shared.files

import one.devsbox.commons.EType

enum class RotationType(override val mask: Int) : EType {
    HORIZONTAL(2),
    VERTICAL(4);


    companion object : EType.Finder<RotationType>(entries)
}

val RotationType.Companion.ALL: Int get() = RotationType.entries.sumOf { it.mask }